/**
 * 三包登记的 表单验证规则
 * @author zjs
 * @time 2017-09-21
 */
export default {
    data () {
        // 非空的判断
        var isNoEmpty = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入'))
            } else {
                callback()
            }
        }
        return {
            formRules: {
                work_time: [{ required: true, trigger: 'blur' }],
                huikuan_time: [{ required: true, trigger: 'blur' }],
                'shoukuanzh.label' : [{ required: true, trigger: 'blur' }],
                shoukuan_amount: [{ validator: isNoEmpty, required: true, trigger: 'blur' }],
                dengjiren: [{ required: true, trigger: 'blur' }]
            }
        }
    },
    methods: {
        /**
         * 验证货品信息
         * @param  {[Array]} arr [货品列表]
         */
        validateProduct (arr) {
            let msg = '' // 提示的信息
            let index = -1 // 记录有问题的行
            for (let i in arr) {
                let row = arr[i]
                // let bool = false
                // 判断是否选择客户编码
                if (!row.customer || !row.customer.customer_account) {
                    msg += '"客户编码"'
                }
                // 是否填写了客户名称
                if (!row.customer || !row.customer.customer_name) {
                    msg += '"客户名称"'
                }
                // 回款金额
                if (!row.huikuan_amount) {
                    msg += '"回款金额"'
                }
                if (msg.length > 0) {
                    index = i
                    break;
                }
            }
            if (index >= 0) {
                msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
            } 
            return msg
        }
    }
}